import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from '@chakra-ui/react';
import React from 'react';
import { convertToCSS, getPaddingValue } from '@/utils';
export const LayoutContainerGridBlock = ({ block, renderBlock }) => {
    const { id, padding, layout_config: { blocks, columns, gap, row_gap } } = block;
    const styles = convertToCSS({ padding });
    const columnGap = getPaddingValue(gap);
    const rowGap = row_gap !== null ? getPaddingValue(row_gap !== null && row_gap !== void 0 ? row_gap : gap) : undefined;
    return (_jsx(Grid, Object.assign({ "data-test": id, sx: styles, columnGap: columnGap, rowGap: rowGap, templateColumns: {
            base: '1fr',
            md: `repeat(${columns}, 1fr)`
        } }, { children: blocks.map((block) => (_jsx(React.Fragment, { children: renderBlock(block) }, block.id))) })));
};
